module.exports = __webpack_public_path__ + "img/Credit card at home Icon - white.1ced46e8.svg";